import { render, staticRenderFns } from "./SubmittedStudentList.vue?vue&type=template&id=05263524&"
import script from "./SubmittedStudentList.vue?vue&type=script&lang=js&"
export * from "./SubmittedStudentList.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedStudentList.vue?vue&type=style&index=0&id=05263524&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports